// @flow
/** @jsx jsx */

import { ContentLoader } from '@zapier/common-components';
import { jsx } from '@emotion/core';

const Skeleton = () => (
  <ContentLoader height="231px">
    <rect height="231" rx="0" ry="0" width="100%" x="0" y="0" />
  </ContentLoader>
);

export default Skeleton;
